import { getAuth } from "firebase/auth";
import { getAuthCentral } from "../../config/FirebaseConfig";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { checkDB } from "../../models/DataFunctions.js";
import addLogDocument from "../addLogDocument";
import axios from "axios";

const sendNotificationParticulier = async (folder_id, token, prefix) => {
  try {
    const auth = getAuthCentral();
    const currentUser = auth.currentUser;

    if (!currentUser) {
      console.error("User not logged in");
      return "";
    }

    const url = `${prefix}folders/${folder_id}/notify-particulier`;
    const body = {};

    const headers = {
      Authorization: `Bearer ${token}`,
    };

    // use axios
    // don(t use formdata

    const response = await axios.post(url, body, {
      headers: headers,
    });

    if (response.status === 200) {
    } else {
    }
  } catch (error) {
    console.error(`Error in sendGuestSignature: ${error.message}`);
  }
};

export default sendNotificationParticulier;
